import { useCallback } from 'react';

import type { CrmManagement_AddSalesCoverage_FirmSearchQueryVariables } from '../graphql/__generated__';
import {
  useCrmManagement_AddSalesCoverage_AdminFirmSearchLazyQuery,
  useCrmManagement_AddSalesCoverage_FirmSearchLazyQuery,
} from '../graphql/__generated__';

export function useAddSalesCoverageFirmSearch(tenantId?: string) {
  const [loadFirmsAsCustomer, { loading: loadingAsCustomer }] =
    useCrmManagement_AddSalesCoverage_FirmSearchLazyQuery();
  const [loadFirmsAsAdmin, { loading: loadingAsAdmin }] =
    useCrmManagement_AddSalesCoverage_AdminFirmSearchLazyQuery();

  const loadFirms = useCallback(
    async (variables: CrmManagement_AddSalesCoverage_FirmSearchQueryVariables) => {
      if (tenantId) {
        const response = await loadFirmsAsAdmin({
          variables: {
            tenantId,
            ...variables,
          },
          fetchPolicy: 'no-cache',
        });
        return {
          ...response,
          data: {
            ...response.data,
            investorFirmsGrid: response.data?.adminInvestorFirmsGrid,
          },
        };
      } else {
        return await loadFirmsAsCustomer({
          variables,
          fetchPolicy: 'no-cache',
        });
      }
    },
    [tenantId, loadFirmsAsAdmin, loadFirmsAsCustomer]
  );

  return {
    loadFirms,
    loading: tenantId ? loadingAsAdmin : loadingAsCustomer,
  };
}
